module.exports = __webpack_public_path__ + "img/message.1d385de1.svg";